import { InteractionProperty } from "../InteractionProperty";

export enum InteractionType {
  Default = "default",
  TeleportMarker = "teleportMarker",
  Marker = "marker",
  LisaMessage = "lisaMessage",
  MessagePopup = "messagePopup",
  ImagePopup = "imagePopup",
  VideoPopup = "videoPopup",
  PdfPopup = "pdfPopup",
  MultipleChoiceQuiz = "multipleChoiceQuiz",
  MultiselectQuiz = "multiselectQuiz",
  MultiSelectGraphicsQuiz = "multiSelectGraphicsQuiz",
  MultipleChoiceGraphicsQuiz = "multipleChoiceGraphicsQuiz",
  OrderQuiz = "orderQuiz",
  OrderGraphicsQuiz = "orderGraphicsQuiz",
  ConnectQuiz = "connectQuiz",
  ConnectGraphicsQuiz = "connectGraphicsQuiz",
  LabelDragAndDropQuiz = "labelDragAndDropQuiz",
  PropLabelQuiz = "propLabelQuiz",
  PropLabelOrderQuiz = "propLabelOrderQuiz",
  ImageDragAndDropQuiz = "imageDragAndDropQuiz",
  ScrabbleQuiz = "scrabbleQuiz",
  WordSpinnerQuiz = "wordSpinnerQuiz",
  ClickRegion = "clickRegion",
  ClickRegionOrderQuiz = "clickRegionOrderQuiz",
  ClickRegionMultiSelectQuiz = "clickRegionMultiSelectQuiz",
  WordQuiz = "wordQuiz",
  PhotoRangeQuiz = "photoRangeQuiz",
  AmbientAudio = "ambientAudio",
  AudioPopup = "audioPopup",
  Conversation = "conversation",
  SetCamera = "setCamera",
  MessageBubble = "messageBubble",
  EmotionBubble = "emotionBubble",
  DialogQuiz = "dialogQuiz",
  Grab = "grab",
  DynamicInteraction = "dynamicInteraction",
  Detach = "detach",
  Attach = "attach",
  Transition = "transition",
  Slideshow = "slideshow",
  ButtonsQuiz = "buttonsQuiz",
  Lookat = "lookat",
  SetPropState = "setPropState",
  ShowUIProp = "showUIProp",
  HideUIProp = "hideUIProp",
  ImageButtonQuiz = "imageButtonQuiz",
  ClickIndicator = "clickIndicator",
  HideClickIndicator = "hideClickIndicator",
  StatementQuiz = "statementQuiz",
  InspectProp = "inspectProp",
  Wait = "wait",
  SetCharacterParts = "setCharacterParts",
  ClearCharacterParts = "clearCharacterParts",
  SetOutfit = "setOutfit",
  Sequence = "sequence",
  ParallelSequence = "parallelSequence",
  AnimateActor = "animateActor",
  StopWalking = "stopWalking",
  ProximityTrigger = "proximityTrigger",
  SendActorToPosition = "sendActorToPosition",
  SubSequence = "subSequence",
  Trigger = "trigger",
  PlaySubSequence = "playSubSequence",
  StopSubSequence = "stopSubSequence",
  TriggerEvent = "triggerEvent",
  WaitForEvent = "waitForEvent",
  WaitForClick = "waitForClick",
  InitializeTimer = "initializeTimer",
  UpdateTimer = "updateTimer",
  GetTimerTime = "getTimerTime",
  ShowCustomQuiz = "showCustomQuiz",
  LoseCustomQuizStar = "loseCustomQuizStar",
  CloseCustomQuiz = "closeCustomQuiz",
  ShowLetterBox = "showLetterBox",
  HideLetterBox = "hideLetterBox",
  If = "if",
  Switch = "switch",
  Math = "math",
  SetVariable = "setVariable",
  SetMovementEnabled = "setMovementEnabled",
  EnableDefaultCamera = "enableDefaultCamera",
  PowerSlide = "powerSlide",
}

export default interface Interaction {
  id: string;
  name: string;
  type: InteractionType;
  properties?: InteractionProperty[];
  /** Excluded from test payloads when true. undefined = enabled. */
  disabled?: boolean;
}

export interface Marker extends Interaction {
  xPos: number;
  yPos: number;
}
